/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProtectedUploadRouteImport } from './routes/_protected/upload'
import { Route as ProtectedPortalCautivoRouteImport } from './routes/_protected/portal-cautivo'
import { Route as ProtectedHistorialRouteImport } from './routes/_protected/historial'
import { Route as ProtectedDashboardRouteImport } from './routes/_protected/dashboard'
import { Route as ProtectedAdminRouteImport } from './routes/_protected/admin'
import { Route as ProtectedAdminIndexRouteImport } from './routes/_protected/admin/index'
import { Route as ProtectedAdminZonasRouteImport } from './routes/_protected/admin/zonas'
import { Route as ProtectedAdminSerieRouteImport } from './routes/_protected/admin/serie'
import { Route as ProtectedAdminDiasServicioRouteImport } from './routes/_protected/admin/dias-servicio'
import { Route as ProtectedAdminCargasRouteImport } from './routes/_protected/admin/cargas'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedUploadRoute = ProtectedUploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedPortalCautivoRoute = ProtectedPortalCautivoRouteImport.update({
  id: '/portal-cautivo',
  path: '/portal-cautivo',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedHistorialRoute = ProtectedHistorialRouteImport.update({
  id: '/historial',
  path: '/historial',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDashboardRoute = ProtectedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAdminRoute = ProtectedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAdminIndexRoute = ProtectedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedAdminRoute,
} as any)
const ProtectedAdminZonasRoute = ProtectedAdminZonasRouteImport.update({
  id: '/zonas',
  path: '/zonas',
  getParentRoute: () => ProtectedAdminRoute,
} as any)
const ProtectedAdminSerieRoute = ProtectedAdminSerieRouteImport.update({
  id: '/serie',
  path: '/serie',
  getParentRoute: () => ProtectedAdminRoute,
} as any)
const ProtectedAdminDiasServicioRoute =
  ProtectedAdminDiasServicioRouteImport.update({
    id: '/dias-servicio',
    path: '/dias-servicio',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminCargasRoute = ProtectedAdminCargasRouteImport.update({
  id: '/cargas',
  path: '/cargas',
  getParentRoute: () => ProtectedAdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof ProtectedAdminRouteWithChildren
  '/dashboard': typeof ProtectedDashboardRoute
  '/historial': typeof ProtectedHistorialRoute
  '/portal-cautivo': typeof ProtectedPortalCautivoRoute
  '/upload': typeof ProtectedUploadRoute
  '/admin/cargas': typeof ProtectedAdminCargasRoute
  '/admin/dias-servicio': typeof ProtectedAdminDiasServicioRoute
  '/admin/serie': typeof ProtectedAdminSerieRoute
  '/admin/zonas': typeof ProtectedAdminZonasRoute
  '/admin/': typeof ProtectedAdminIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof ProtectedDashboardRoute
  '/historial': typeof ProtectedHistorialRoute
  '/portal-cautivo': typeof ProtectedPortalCautivoRoute
  '/upload': typeof ProtectedUploadRoute
  '/admin/cargas': typeof ProtectedAdminCargasRoute
  '/admin/dias-servicio': typeof ProtectedAdminDiasServicioRoute
  '/admin/serie': typeof ProtectedAdminSerieRoute
  '/admin/zonas': typeof ProtectedAdminZonasRoute
  '/admin': typeof ProtectedAdminIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/login': typeof LoginRoute
  '/_protected/admin': typeof ProtectedAdminRouteWithChildren
  '/_protected/dashboard': typeof ProtectedDashboardRoute
  '/_protected/historial': typeof ProtectedHistorialRoute
  '/_protected/portal-cautivo': typeof ProtectedPortalCautivoRoute
  '/_protected/upload': typeof ProtectedUploadRoute
  '/_protected/admin/cargas': typeof ProtectedAdminCargasRoute
  '/_protected/admin/dias-servicio': typeof ProtectedAdminDiasServicioRoute
  '/_protected/admin/serie': typeof ProtectedAdminSerieRoute
  '/_protected/admin/zonas': typeof ProtectedAdminZonasRoute
  '/_protected/admin/': typeof ProtectedAdminIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/dashboard'
    | '/historial'
    | '/portal-cautivo'
    | '/upload'
    | '/admin/cargas'
    | '/admin/dias-servicio'
    | '/admin/serie'
    | '/admin/zonas'
    | '/admin/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard'
    | '/historial'
    | '/portal-cautivo'
    | '/upload'
    | '/admin/cargas'
    | '/admin/dias-servicio'
    | '/admin/serie'
    | '/admin/zonas'
    | '/admin'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/login'
    | '/_protected/admin'
    | '/_protected/dashboard'
    | '/_protected/historial'
    | '/_protected/portal-cautivo'
    | '/_protected/upload'
    | '/_protected/admin/cargas'
    | '/_protected/admin/dias-servicio'
    | '/_protected/admin/serie'
    | '/_protected/admin/zonas'
    | '/_protected/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/upload': {
      id: '/_protected/upload'
      path: '/upload'
      fullPath: '/upload'
      preLoaderRoute: typeof ProtectedUploadRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/portal-cautivo': {
      id: '/_protected/portal-cautivo'
      path: '/portal-cautivo'
      fullPath: '/portal-cautivo'
      preLoaderRoute: typeof ProtectedPortalCautivoRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/historial': {
      id: '/_protected/historial'
      path: '/historial'
      fullPath: '/historial'
      preLoaderRoute: typeof ProtectedHistorialRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/dashboard': {
      id: '/_protected/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ProtectedDashboardRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/admin': {
      id: '/_protected/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof ProtectedAdminRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/admin/': {
      id: '/_protected/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof ProtectedAdminIndexRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/zonas': {
      id: '/_protected/admin/zonas'
      path: '/zonas'
      fullPath: '/admin/zonas'
      preLoaderRoute: typeof ProtectedAdminZonasRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/serie': {
      id: '/_protected/admin/serie'
      path: '/serie'
      fullPath: '/admin/serie'
      preLoaderRoute: typeof ProtectedAdminSerieRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/dias-servicio': {
      id: '/_protected/admin/dias-servicio'
      path: '/dias-servicio'
      fullPath: '/admin/dias-servicio'
      preLoaderRoute: typeof ProtectedAdminDiasServicioRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/cargas': {
      id: '/_protected/admin/cargas'
      path: '/cargas'
      fullPath: '/admin/cargas'
      preLoaderRoute: typeof ProtectedAdminCargasRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
  }
}

interface ProtectedAdminRouteChildren {
  ProtectedAdminCargasRoute: typeof ProtectedAdminCargasRoute
  ProtectedAdminDiasServicioRoute: typeof ProtectedAdminDiasServicioRoute
  ProtectedAdminSerieRoute: typeof ProtectedAdminSerieRoute
  ProtectedAdminZonasRoute: typeof ProtectedAdminZonasRoute
  ProtectedAdminIndexRoute: typeof ProtectedAdminIndexRoute
}

const ProtectedAdminRouteChildren: ProtectedAdminRouteChildren = {
  ProtectedAdminCargasRoute: ProtectedAdminCargasRoute,
  ProtectedAdminDiasServicioRoute: ProtectedAdminDiasServicioRoute,
  ProtectedAdminSerieRoute: ProtectedAdminSerieRoute,
  ProtectedAdminZonasRoute: ProtectedAdminZonasRoute,
  ProtectedAdminIndexRoute: ProtectedAdminIndexRoute,
}

const ProtectedAdminRouteWithChildren = ProtectedAdminRoute._addFileChildren(
  ProtectedAdminRouteChildren,
)

interface ProtectedRouteChildren {
  ProtectedAdminRoute: typeof ProtectedAdminRouteWithChildren
  ProtectedDashboardRoute: typeof ProtectedDashboardRoute
  ProtectedHistorialRoute: typeof ProtectedHistorialRoute
  ProtectedPortalCautivoRoute: typeof ProtectedPortalCautivoRoute
  ProtectedUploadRoute: typeof ProtectedUploadRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedAdminRoute: ProtectedAdminRouteWithChildren,
  ProtectedDashboardRoute: ProtectedDashboardRoute,
  ProtectedHistorialRoute: ProtectedHistorialRoute,
  ProtectedPortalCautivoRoute: ProtectedPortalCautivoRoute,
  ProtectedUploadRoute: ProtectedUploadRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
